module.exports = __webpack_public_path__ + "static/media/igGray.c48d0a37.svg";